// extracted by mini-css-extract-plugin
module.exports = {"title":"search_title__Z_jg5","subtitle":"search_subtitle__Cm_KL"};